module.exports = __webpack_public_path__ + "img/sequire.743ff1a2.svg";